import { CognitoUser as AwsCognitoUser } from "amazon-cognito-identity-js";

export type AuthChallengeName = "NEW_PASSWORD_REQUIRED" | "SMS_MFA" | "SOFTWARE_TOKEN_MFA" | "MFA_SETUP";

export const MFA_SOFTWARE_TOKEN = "SOFTWARE_TOKEN_MFA" as const;
export const MFA_NONE = "NOMFA" as const;
export type MfaPreference = typeof MFA_NONE | typeof MFA_SOFTWARE_TOKEN;

/**
 * The attribute AuthChallengeName is missing in the CognitoUser definition.
 * https://github.com/aws-amplify/amplify-js/issues/3733
 */
export type CognitoUser = AwsCognitoUser & {
  challengeName: AuthChallengeName;
};
